/**
 * @fileoverview Reports page entry — composes hooks and presentational layout.
 * @module pages/Reports
 */
import useReports from "./reports/useReports.js";
import ReportsView from "./reports/ReportsView.jsx";

/** Composes Reports state/handlers and presentational layout. */
const Reports = () => {
  const viewModel = useReports();
  return <ReportsView {...viewModel} />;
};

export default Reports;
